export const getAccountById = "getAccountById";
export const getReferenceDataRepair = "getReferenceDataRepair";
export const getContractors = "getContractors";
export const getDeterminedContractor = "getDeterminedContractor";
export const getAccountUniversal = "getAccountUniversal";
export const getAlert = "getAlert";
export const getKeyContact = "getKeyContact";
export const getTransactionsSearch = "getTransactionsSearch";
export const getCustomerData = "getCustomerData";
export const getRepairDiagnosticToken = "getRepairDiagnosticToken";
export const updateRepairDiagnosticsSession = "updateRepairDiagnosticsSession";
export const getRepairDiagnosticFinalStatus = "getRepairDiagnosticFinalStatus";
export const getPropertyData  = "getPropertyData";
export const getAppConfigSearhTextCount = "getAppConfigSearhTextCount";
export const getWorksOrdersApi = "getWorksOrdersApi";
export const getCaseData = "getCaseData";
export const getAppConfigToggleValue = "getAppConfigToggleValue";
export const getPropertyAssociates = "getPropertyAssociates";
export const getCancelRepairEligibility = "getCancelRepairEligibility";
export const getUntidyTenancy = "getUntidyTenancy";
export const getUCCReferenceData = "getUCCReferenceData";
export const getSearchCustomer  = "getSearchCustomer";
export const getCaseQuestionnaireMasterData = "getCaseQuestionnaireMasterData";
export const getCaseAssetAssociate = "getCaseAssetAssociate";
export const getCasesList = "getCasesList";
export const getCaseHistories = "getCaseHistories";
export const getCaseListData = "getCaseListData";
export const repairPriorityDetermination = "repairPriorityDetermination";
export const sendSMSNotification = "sendSMSNotification";
export const getMediaData = "getMediaData";
export const getViewMediaDetails = "getViewMediaDetails";
export const getRepairMediaData = "getRepairMediaData";
export const getRepairViewMediaDetails = "getRepairViewMediaDetails";
export const getFinancialReferralReasonData = "getFinancialReferralReasonData";
export const GetHighRiseProperty = "GetHighRiseProperty";
export const GetExternalWorkOrderContractors = "GetExternalWorkOrderContractors";
export const getServiceCard = "getServiceCard";
export const getDMCCaseData = "getDMCCaseData";
export const getAssociatedAssets = "getAssociatedAssets";
export const getAssociatedAssetsKey = "getAssociatedAssetsKey";
export const getAssetsById = "getAssetsById";
export const getAccountByIdServiceCharges = "getAccountByIdServiceCharges";
export const getAccountsByCustomerId = "getAccountsByCustomerId";
export const getGasBoilerServiceCompliance="getGasBoilerServiceComplianceByUprn";
export const getEICR5YServiceCompliance="getEICR5YServiceComplianceByUprn";
export const getRepairNotes ="getRepairNotes";
export const getCustomer="getCustomer";
export const getTenancies = "getTenancies";
export const fetchAccountData = "fetchAccountData";
export const getRepairHistories = "getRepairHistories";
export const getWorkOrderEntity = "getWorkOrderEntity";
export const getWorkOrderByIdAPI= "getWorkOrderByIdAPI";
export const getWorkOrder = "getWorkOrder";

